export default class JSScanner {
  constructor(options) {
    const CODE_NUMBER = Array.from({ length: 10 }, (v, k) => `Digit${k}`)
    const CODE_ABC = Array.from({ length: 26 }, (v, k) => `Key${String.fromCharCode(k + 65).toUpperCase()}`)
    this._options = Object.assign(
      {
        code: '',
        lastTime: 0,
        delayTimes: [40, 60, 80],
        scanning: true,
        downkeys: [],
        upkeys: [],
        dictionary: CODE_NUMBER.concat(CODE_ABC),
        callback: function () {},
        // 相邻字符平均间隔上限（ms），扫码枪约 15~50ms，手敲通常 > 100ms，与码长无关
        maxAvgKeyInterval: 80,
        // 添加最小扫码长度（防止短字符被误判）
        minScanLength: 5,
        // 记录第一个按键的时间
        firstKeyTime: 0,
      },
      options
    )
    this._onKeyDown = null
    this._onKeyUp = null
  }

  /**
   * 过滤中文输入法组合输入事件，避免将 Process 等占位键值误判为扫码内容
   * @param {KeyboardEvent} event
   * @returns {boolean}
   */
  isIMEEvent(event) {
    if (!event) return false
    const { key, isComposing, keyCode, which } = event
    return isComposing || key === 'Process' || keyCode === 229 || which === 229
  }

  setCode() {
    //旧代码
    // const length = this._options.upkeys.length
    //新添加
    const totalKeys = this._options.upkeys.length
    let validKeyCount = 0
    // 在循环前保存最后一个按键的时间，因为循环会修改upkeys数组
    const lastKeyTime = totalKeys > 0 ? this._options.upkeys[totalKeys - 1].time : 0

    while (this._options.downkeys.length > 0) {
      const down = this._options.downkeys.shift()
      const up = this._options.upkeys.shift()
      if (!down || !up) continue
      const diffTime = up.time - down.time
      //旧方法
      // if (this._options.delayTimes.some((time) => diffTime <= time)) {
      //   this._options.code += up.key
      // }

      //新方法
      // 使用更严格的单个按键时间差判断
      if (this._options.delayTimes.some((time) => diffTime <= time)) {
        this._options.code += up.key
        validKeyCount++
      }
    }
    //旧方法
    // if (typeof this._options.callback === 'function') {
    //   const isScan = this._options.code.length > 0 && this._options.code.length == length
    //   this._options.callback(this._options.code, isScan)
    // }
    
    //新方法
    if (typeof this._options.callback === 'function') {
      // 增强 isScan 的判断条件：
      // 1. 有有效按键
      // 2. 有效按键数量达到最小扫码长度
      // 3. 平均字符间隔在阈值内（与码长无关，18 位和 26 位用同一标准）
      // 4. 大部分按键都符合扫码的时间特征（有效按键比例高）
      const totalInputTime = lastKeyTime - this._options.firstKeyTime
      const avgKeyInterval =
        validKeyCount > 1 ? totalInputTime / (validKeyCount - 1) : totalInputTime

      // 有效按键比例，扫码枪输入的有效按键比例应该接近 100%
      const validKeyRatio = totalKeys > 0 ? validKeyCount / totalKeys : 0

      const isScan =
        validKeyCount > 0 &&
        validKeyCount >= this._options.minScanLength &&
        avgKeyInterval <= this._options.maxAvgKeyInterval &&
        validKeyRatio > 0.8 // 至少 80% 的按键符合扫码时间特征
      //  console.log('TIPS JSScanner setCode:', this._options.code, new Date().getTime())
      this._options.callback(this._options.code, isScan)
    }
    this.reset()
  }

  onKeydown(event) {
    if (!this._options.scanning) return
    if (this.isIMEEvent(event)) return
    const time = new Date().getTime()
    if (time - this._options.lastTime > 500) {
      this.reset()
      // 记录第一个按键的时间
      this._options.firstKeyTime = time
    }
    this._options.lastTime = time
    let { key, code } = event
    //  console.log('TIPS JSScanner onKeydown:', key,code, new Date().getTime())
    if (code == '') code = code.concat('Digit', key)
    if (this._options.dictionary.includes(code)) {
      const down_time = new Date().getTime()
      this._options.downkeys.push({ key, time: down_time })
    }
  }

  onKeyUp(event) {
    if (!this._options.scanning) return
    if (this.isIMEEvent(event)) return
    let { key, code } = event
    // console.log('TIPS JSScanner onKeyUp:', key,code, new Date().getTime())
    if (key === 'Enter') {
      this.setCode()
      return
    }
    if (code == '') code = code.concat('Digit', key)
    if (this._options.dictionary.includes(code)) {
      const up_time = new Date().getTime()
      this._options.upkeys.push({ key, time: up_time })
    }
  }

  on(callback) {
    this._options.callback = callback
    this._onKeyDown = this.onKeydown.bind(this)
    this._onKeyUp = this.onKeyUp.bind(this)
    window.addEventListener('keydown', this._onKeyDown)
    window.addEventListener('keyup', this._onKeyUp)
  }

  off() {
    window.removeEventListener('keydown', this._onKeyDown)
    window.removeEventListener('keyup', this._onKeyUp)
  }

  reset() {
    this._options.code = ''
    this._options.lastTime = 0
    this._options.firstKeyTime = 0
    this._options.downkeys = []
    this._options.upkeys = []
  }
}
